/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Uppercase_Before_ColonInputs */

const en_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove uppercase text before ':'`)
};

const fr_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le texte en majuscules avant ':'`)
};

const de_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne den Großbuchstaben vor dem Doppelpunkt.`)
};

const it_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi il testo maiuscolo prima di ':'`)
};

const ru_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите заглавные буквы перед символом ':'.`)
};

const es_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar el texto en mayúsculas antes de ':'`)
};

const zh_cn2_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除冒号 (:) 之前的全部大写字母`)
};

const ja_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`':' の前の大文字のテキストを削除します`)
};

const hi_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`':' से पहले के बड़े अक्षरों को हटा दें`)
};

const pt_pt2_remove_uppercase_before_colon = /** @type {(inputs: Remove_Uppercase_Before_ColonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remova o texto em maiúsculas antes de ':'`)
};

/**
* | output |
* | --- |
* | "Remove uppercase text before ':'" |
*
* @param {Remove_Uppercase_Before_ColonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_uppercase_before_colon = /** @type {((inputs?: Remove_Uppercase_Before_ColonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Uppercase_Before_ColonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_uppercase_before_colon(inputs)
	if (locale === "de") return de_remove_uppercase_before_colon(inputs)
	if (locale === "it") return it_remove_uppercase_before_colon(inputs)
	if (locale === "ru") return ru_remove_uppercase_before_colon(inputs)
	if (locale === "es") return es_remove_uppercase_before_colon(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_uppercase_before_colon(inputs)
	if (locale === "ja") return ja_remove_uppercase_before_colon(inputs)
	if (locale === "hi") return hi_remove_uppercase_before_colon(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_uppercase_before_colon(inputs)
	return en_remove_uppercase_before_colon(inputs)
});